import localforage from 'localforage';
import { LOCAL_STORAGE_NAMESPACE } from '../../config/constants';

let instance: LocalForage | undefined;

const localStore = (): LocalForage => {
  if (!instance) {
    instance = localforage.createInstance({
      driver: localforage.LOCALSTORAGE, // TODO: test without this at somepoint. I (Greg) couldn't get `setItem` to work without the LOCALSTORAGE driver
      name: LOCAL_STORAGE_NAMESPACE,
    });
  }
  return instance;
};

export default localStore();
